import React from 'react'
import styled, { css } from 'styled-components'

import { getDangerColor } from './utils'
import { CustomStyleOverrideProps } from './types'
import { Typography, TypographyProps } from '../Typography'

export type FormLabelProps = TypographyProps & {
  hasError?: boolean
  children?: React.ReactNode
  baseOverrides?: Partial<CustomStyleOverrideProps>
}

const FormLabel = styled(Typography)<FormLabelProps>`
  font-weight: bold;
  margin-bottom: 7px;

  ${(props) =>
    props.hasError &&
    css`
      color: ${getDangerColor(props.baseOverrides)};
    `}
`

export const RequiredWrapper = ({
  children,
  required,
  baseOverrides,
}: {
  children: React.ReactNode
  required?: boolean
  baseOverrides?: Partial<CustomStyleOverrideProps>
}) => {
  if (!required) return <>{children}</>
  return (
    <div
      css={`
        display: flex;
        align-items: center;
        gap: 3px;
      `}
    >
      {children}
      <span
        css={`
          color: ${getDangerColor(baseOverrides)};
        `}
      >
        *
      </span>
    </div>
  )
}

export default FormLabel
